export const OSSDomain = 'https://papanmemorial-ver2.oss-ap-southeast-3.aliyuncs.com'

export const orderStatusCode = {
  P: "Pending Approval",
  R: "Rejected",
  A: "Approved",
  RF: "Refunded",
  CCL: "Canceled",
  S: "Suspended"
};

export const statusConst = {
  A: "Available",
  B: "Booked",
  S: "Sold",
  N: "Not Available",
  C: "In Construction"
};

export const lotType = {
  B: {
    1: "Standard Single",
    2: "Standard Double",
    4: "Mini Family"
  },
  N: {
    1: "Niche Single",
    2: "Niche Double",
    3: "Niche Triple"
  }
}

export const unitTypeConst = {
  B: "Burial",
  N: "Niche"
};

export const SALES_TYPE_CONFIG = {
  2: {
    buttonText: "{{RELEASE_LOT}}",
    modalTitle: "{{RELEASE_LOT}}"
  },
  3: {
    buttonText: "{{CANCEL_FSP}}",
    modalTitle: "{{CANCEL_FSP}}"
  },
  4: {
    buttonText: "{{CANCEL_MERCHANDISE}}",
    modalTitle: "{{CANCEL_MERCHANDISE}}"
  },
  5: {
    buttonText: "{{CANCEL_PURCHASE}}",
    modalTitle: "{{CANCEL_PURCHASE}}"
  },
  9: {
    buttonText: "{{CANCEL_MONUMENT}}",
    modalTitle: "{{CANCEL_MONUMENT}}"
  }
};
